/**
 * custom breakpoints for theme
 */
const customBreakpoints = Object.freeze({
  values: {
    /** default values other than mobileCutoff */
    xs: 0,
    sm: 600,
    md: 900,
    mobileCutoff: 960,
    lg: 1200,
    xl: 1536,
  },
})

export default customBreakpoints
